import { jsx as _jsx } from "react/jsx-runtime";
import { v1 } from 'uuid';
import { HeaderItem } from '../header-item';
import s from './header-list.module.scss';
export const HeaderList = ({ resultData, listRef, setResultData, setSearchValue, isLiteEnabled }) => {
    return (_jsx("div", { ref: listRef, className: s.list, children: _jsx("div", { className: s.listInner, children: resultData?.map(el => (_jsx(HeaderItem, { setResultData: setResultData, setSearchValue: setSearchValue, isLiteEnabled: isLiteEnabled, ...el }, v1()))) }) }));
};
